import styles from './ManageDiv.module.css';
import Button from '../../Button/Button';
import {getAllDivisionsUrl, getAllUsersInitialsUrl} from '../../../helpers/constants';
import React, {useEffect, useReducer, useState} from 'react';
import {SelectForm} from '../../SelectForm/SelectForm';
import {Tooltip} from 'react-tooltip';
import InputForm from '../../InputForm/InputForm';
import {formReducer, INITIAL_STATE} from './manageDiv.state';
import useApi from '../../../hooks/useApi.hook';
import useFillSelect from '../../../hooks/useFillSelect.hook';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';

export function ManageDiv({optionsDiv, divisionDict, getDivisions}) {
	const [errorApi, setErrorApi] = useState(undefined);
	const [state, dispatchForm] = useReducer(formReducer, INITIAL_STATE);
	const [loading, setLoading] = useState(false);
	const [uploadedOk, setUploadedOk] = useState(false);
	const api = useApi();
	const {
		valueDiv,
		subModalOpen,
		visibleDelButton,
		values,
		isValid,
		errors,
		isFormReadyToSubmit
	} = state;

	const {
		error: errorUser,
		options: optionsUsers,
		itemDict: modulesUsers,
		getItems: getUsers
	} = useFillSelect({
		endpoint: getAllUsersInitialsUrl,
		labelField: 'last_name_with_initials'
	});

	const userOptions = (optionsUsers || []).map(u =>
		u?.value !== undefined && u?.label !== undefined
			? u
			: { value: u.id, label: u.last_name_with_initials }
	);

	const valueUser = userOptions.find(o => String(o.value) === String(values.responsible_id)) ?? null;
	const optionsDivWide = [
		{value: 0, label: '---Создать новое подразделение---'},
		...optionsDiv
	];

	const renderButtonText = () => {
		if (loading) return 'Загрузка…';
		if (uploadedOk) return valueDiv ? '✓ Сохранен' : '✓ Удален';
		return valueDiv ? 'Редактировать' : 'Создать';
	};

	const showSuccess = (ms = 1500) => {
		setUploadedOk(true);
		setTimeout(() => setUploadedOk(false), ms);
	};

	const manageDivApi = async (payload, isDelete = false) => {
		let response;
		setLoading(true);
		try {
			if (valueDiv) {
				if (isDelete) {
					await api.delete(`${getAllDivisionsUrl}${valueDiv}`);
				} else {
					response = await api.patch(`${getAllDivisionsUrl}${valueDiv}`, payload);
				}
			} else {
				response = await api.post(`${getAllDivisionsUrl}`, payload);
			}
			await getDivisions();
			if (response) {
				const { id, title, description } = response.data;
				dispatchForm({type: 'SET_SUB_MODAL', payload: false});
				dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: true});
				dispatchForm({type: 'SET_VALUE_DIV', payload: Number(id)});
				dispatchForm({type: 'RESET_VALIDITY'});
				dispatchForm({
					type: 'SET_VALUE', payload:
					{
						'title': title,
						'description': description,
						'responsible_id': response.data?.responsible_id ?? null
					}}
				);
			}
			showSuccess(1500);
		} catch (e) {
			setErrorApi(
				e.response?.data?.detail || e.response?.data?.message || 'Неизвестная ошибка'
			);
		} finally {
			setLoading(false);
		}
	};

	const selectDiv = (option) => {
		console.log('[selectDiv] option =', option);
		console.log('[selectDiv] option.responsible_id =', option?.responsible_id, 'type:', typeof option?.responsible_id);
		dispatchForm({type: 'SET_SUB_MODAL', payload: false});
		dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: true});
		dispatchForm({type: 'SET_VALUE_DIV', payload: Number(option.value)});
		dispatchForm({type: 'RESET_VALIDITY'});
		if (option.value !== 0) {
			const div = divisionDict?.[String(option.value)] ?? divisionDict?.[Number(option.value)];
			dispatchForm({
				type: 'SET_VALUE',
				payload: {
					title: div?.title ?? option.label,
					description: div?.description ?? '',
					responsible_id: div?.responsible_id ?? null
				}
			});
		} else {
			dispatchForm({type: 'CLEAR'});
		}
	};

	const onChange = (e) => {
		dispatchForm({type: 'SET_SUB_MODAL', payload: false});
		dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: false});
		dispatchForm({type: 'SET_VALUE', payload: { [e.target.name]: e.target.value}});
		dispatchForm({type: 'RESET_VALIDITY'});
	};

	const onResponsibleChange = (option) => {
		dispatchForm({ type: 'SET_SUB_MODAL', payload: false });
		dispatchForm({ type: 'SET_VISIBLE_DEL_BUTTON', payload: false });
		dispatchForm({ type: 'SET_VALUE', payload: { responsible_id: option?.value ?? null }});
		dispatchForm({ type: 'RESET_VALIDITY' });
		dispatchForm({ type: 'RESET_VALIDITY' });
	};

	const creatEditDiv = () => {
		dispatchForm({type: 'SUBMIT'});
	};

	const deleteDiv = () => {
		manageDivApi({}, true);
		dispatchForm({ type: 'CLEAR' });
		dispatchForm({type: 'SET_VALUE_DIV', payload: 0});
		dispatchForm({type: 'SET_SUB_MODAL', payload: false});
	};

	useEffect(() => {
		if (isFormReadyToSubmit) {
			manageDivApi(values);
			dispatchForm({ type: 'SET_SUBMIT_FALSE' });
		}
	}, [isFormReadyToSubmit]);

	const selectedOption = optionsDivWide.find(o => Number(o.value) === Number(valueDiv)) || optionsDivWide[0];

	return (
		<div className={styles['manage_div']}>
			<h1 className={styles['title']}>Управление подразделениями</h1>
			<ErrorMessage
				error={errorApi}
				onClose={() => setErrorApi(undefined)}
			/>
			<div className={styles['content']}>
				<span className={styles['span']}>
					Подразделения:
					<SelectForm
						value={selectedOption}
						options={optionsDivWide}
						name="Division_id"
						onChange={selectDiv}
					/>
				</span>
				<div className={styles['box']}>
					<span className={styles['box-title']}>Параметры подразделения</span>
					<div className={styles['box-content']}>
						<span
							className={styles['span']}
							data-tooltip-content={errors.title}
							data-tooltip-id="errorTooltipTitle"
						>
						Наименование*:
							<InputForm
								value={values.title}
								isValid={isValid.title}
								type="text"
								name="title"
								placeholder="Наименование"
								onChange={onChange}
							/>
							<Tooltip
								id="errorTooltipTitle"
								place="top-end"
								content={errors.title}
								isOpen={!isValid.title}
								className={styles['my-tooltip']}
							/>
						</span>
						<span className={styles['span']}>
						Описание:
							<InputForm
								value={values.description ?? ''}
								type="text"
								name="description"
								placeholder="Описание"
								onChange={onChange}
							/>
						</span>
						<span className={styles['span']}>
						Ответственный:
							<SelectForm
								value={valueUser}
								placeholder={'Выберите отвественного'}
								options={userOptions}
								name="Responsible_id"
								onChange={onResponsibleChange}
							/>
						</span>
						<div className={styles['button-box']}>
							{(Boolean(valueDiv) && visibleDelButton) && <div className={styles['inline']}>
								<button className={styles.iconButton}
									onClick={() => {
										dispatchForm({type: 'SET_SUB_MODAL', payload: true});
										dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: false});

									}}
								>
									<img
										className={styles.iconImage}
										src="/icons/delete-icon.svg"
										alt="delete"/>
								</button>
							</div>}
							{subModalOpen && <div className={styles['submodal']}>
								<Button className={styles.button_submodal} onClick={deleteDiv}>
										Удалить
								</Button>
								<Button className={styles.button_submodal} onClick={() => {
									dispatchForm({type: 'SET_SUB_MODAL', payload: false});
									dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: true});
								}}>
										Отмена
								</Button>
							</div>
							}
						</div>
					</div>
				</div>
			</div>
			<div className={styles['button']}>
				<Button
					onClick={creatEditDiv}
					disabled={loading}
					className={`${styles.uploadBtn} ${uploadedOk ? styles.uploadedOkBtn : ''}`}
				>
					{renderButtonText()}
				</Button>
			</div>
		</div>
	);
}
